// components/PageTitle.js
import React from "react";

const Breadcrumb = ({ title, breadcrumb, description }) => {
  return (
    <div className="prt-page-title-row overflow-hidden">
      <div className="prt-page-title-row-inner" style={{ padding: '80px 0 40px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="prt-page-title-row-heading">
                <div className="banner-vertical-block"></div>
                <div className="page-title-heading">
                  <h2 className="title" style={{
                    fontSize: '48px',
                    lineHeight: '56px',
                    '@media (maxWidth: 991px)': {
                      fontSize: '36px',
                      lineHeight: '44px'
                    }
                  }}>
                    <style>{`
                      @media (max-width: 991px) {
                        .page-title-heading .title {
                          font-size: 36px !important;
                          line-height: 44px !important;
                        }
                      }
                      @media (max-width: 575px) {
                        .page-title-heading .title {
                          font-size: 28px !important;
                          line-height: 36px !important;
                        }
                      }
                    `}</style>
                    {title}
                  </h2>
                </div>
                <div className="breadcrumb-wrapper">
                  {breadcrumb
                    .filter((item) => item.name.trim() !== "")
                    .map((item, index, arr) => (
                      <span key={index}>
                        {item.link ? (
                          <a title={item.name} href={item.link}>
                            {item.name}
                          </a>
                        ) : (
                          <span className="action">{item.name}</span>
                        )}
                        {/* {index < arr.length - 1 && " / "} */}
                      </span>
                    ))}
                </div>
                {description && (
                  <div className="page-title-description" style={{
                    marginTop: '15px',
                    fontSize: '16px',
                    lineHeight: '1.6',
                    color: '#666',
                    maxWidth: '800px'
                  }}>
                    <p style={{ margin: 0 }}>{description}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Optionally include a background overlay if needed */}
      </div>
    </div>
  );
};

export default Breadcrumb;
